export const ROLE_ADMIN_USER = 'admin-user';
export const ROLE_EMPLOYEE_USER = 'employee';
export const ROLE_COORDINATOR = 'hotel-coordinator';
export const ROLE_LERE_ADMIN = 'lere-admin';
export const ROLE_LERE_USER = 'lere-user';
export const ROLE_EXPERIENCES_COORDINATOR = 'experiences-coordinator';
export const ROLE_PRIZE_ADMIN_USER = 'prize_administrator';
export const ROLE_PROMO_ADMIN_USER = 'promo-admin';
export const ROLE_CHANNEL_MARKUP_ADMIN_USER = 'channel-markup-admin';
export const ROLE_LESA_ADMIN = 'support-assistant-admin';
export const ROLE_HOTEL_COORDINATOR = 'hotel-coordinator';
export const ROLE_SEARCH_CURATOR = 'search-curator';
export const ROLE_CRUISE_COORDINATOR = 'cruise-coordinator';
export const ROLE_TOUR_COORDINATOR = 'tour-coordinator';
export const ROLE_HERO_PLANNER_ADMIN = 'hero-planner-admin';
export const ROLE_HERO_PLANNER_VIEWER = 'hero-planner-viewer';
export const ROLE_LUX_PLUS_ADMIN = 'lux-plus-admin';
export const ROLE_ICS_STORE_TEAM = 'ics-store-team';
export const ROLE_CUSTOM_OFFER_ADMIN_USER = 'custom-offer-admin';
export const ROLE_LUX_LOYALTY_ADMIN = 'lux-loyalty-admin';
export const ROLE_VENDOR_ADMIN = 'vendor-admin';
export const ROLE_VENDOR_USER = 'vendor-user';
export const ROLE_CX_TEAM_LEADER = 'cx-team-leader';
